/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';
import Button from 'elements/Button';

export default class CareersPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const benefits = [
      {
        title: 'Employee Growth Programs',
        description: 'Our growth is directly proportional to our employees\' personal and professional growth, therefore we support their learning by training them and also offering them immense growth opportunities.',
        icon: '📈',
      },
      {
        title: 'Work That Challenges You',
        description: 'Work is never monotonous at ERapid. Boring tasks and monotonous work schedule is a big "No" at our workplace. We keep throwing challenges your way to expand your learning scope and keep you engaged.',
        icon: '💪',
      },
      {
        title: 'Fabulous Peers',
        description: 'Our team has amazing humans who are not only fabulous at their job but also amazing colleagues who support and entertain each other.',
        icon: '👥',
      },
      {
        title: 'Fast-Track Growth',
        description: 'We believe that "Talent has no boundaries". So, If you have what it takes to become a leader, We will help you grow in your career by providing you with brilliant growth opportunities.',
        icon: '🚀',
      },
      {
        title: 'Paid Leaves',
        description: 'We understand that our employees need a break from work every once in a while. Therefore we provide them with paid leaves and sick leaves (limited of course!). So yes, you can plan a vacation with your friends and family.',
        icon: '🏖️',
      },
      {
        title: 'Make a Difference',
        description: 'Our goal is to make the IT world more advanced and feasible for everyone. Come and join us in our epic journey toward innovation.',
        icon: '🌟',
      },
      {
        title: 'Jolly-Times',
        description: 'Not a single day seems dull at ERapid. We organize fun activities such as Happy hours, birthdays and festival celebrations, HR activities, annual trips, and much more, so can stay happy and entertained while working with us. Work hard and party harder with us!',
        icon: '🎉',
      },
      {
        title: 'Flexible Work Culture',
        description: 'We understand that everyone has a working pattern. So, we let our employees choose their work-timing slots. And there is no dress code and flexible break timings.',
        icon: '⏰',
      },
      {
        title: 'Work-Life Integration',
        description: 'We want you to be your true self when you are with us. We never expect our employees to pretend that they have two personas, a professional one and a "real" one. With us, you can feel free of formal bondage and let us know "Who you really are?"',
        icon: '⚖️',
      },
      {
        title: 'Home-Office Arrangements',
        description: 'We promote a home-office arrangement in which you can personalize your workspace. You can customize your workspace with all the accessories that make you feel at home and help you to stay productive.',
        icon: '🏠',
      },
    ];

    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-16 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                Careers
              </h1>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                Join our team and be part of building innovative solutions that transform
                businesses.
              </p>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-4">
                Why Should You Join Our Team?
              </h2>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto">
                Wondering If ERapid is an apt choice for your professional journey?
                Here are a few things about us that will surely impress you:
              </p>
            </Fade>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {benefits.map((benefit, index) => (
                <Fade bottom delay={200 * index} key={benefit.title}>
                  <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105 h-full">
                    <div className="text-4xl mb-4">{benefit.icon}</div>
                    <h3 className="text-xl font-semibold text-theme-blue mb-3">
                      {benefit.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {benefit.description}
                    </p>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl lg:text-4xl text-theme-blue text-center font-bold mb-6">
                  Become a Part of Team ERapid
                </h2>
                <p className="text-gray-600 mb-8 leading-relaxed text-center">
                  At ERapid, Your work might be challenging but you will also find immense
                  growth opportunities here. Also, the Road Trips, Weekly Parties, Office
                  Celebrations, and other recreational activities will help you to get through
                  your week. Our work environment offers you fun, flexibility, learning
                  opportunities, career growth, and whatnot! Trust us we would never stop
                  surprising you with our amazing work culture. Join us to explore what we have
                  in the box for you.
                </p>
                <div className="text-center">
                  <Button
                    href="/discuss-project"
                    type="link"
                    className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-105"
                  >
                    Send Your CV
                    <svg className="ml-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Button>
                </div>
              </div>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-3xl lg:text-4xl text-theme-blue text-center font-bold mb-12">
                Current Openings
              </h2>
              <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8 mb-8">
                  <div className="flex flex-wrap gap-2 mb-4">
                    <span className="px-3 py-1 bg-theme-purple/10 text-theme-purple rounded-lg text-sm font-semibold">
                      Role: Marketing and Sales Intern
                    </span>
                    <span className="px-3 py-1 bg-theme-blue/10 text-theme-blue rounded-lg text-sm font-semibold">
                      Experience: Fresher/Experienced
                    </span>
                    <span className="px-3 py-1 bg-green-100 text-green-700 rounded-lg text-sm font-semibold">
                      Vacancies: 25
                    </span>
                    <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-lg text-sm font-semibold">
                      Location: New Delhi
                    </span>
                  </div>
                  <h3 className="text-2xl font-bold text-theme-blue mb-4">
                    Technical Sales and Marketing Intern
                  </h3>
                  <p className="text-gray-600 mb-4 font-semibold">
                    Internship Period: 2-3 months
                  </p>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Embark on an exciting journey into the heart of the IT universe as a
                    {' '}
                    <strong>
                      Technical Sales and Marketing Intern at ERapid Technologies.
                    </strong>
                    {' '}
                    Our internship program is not just about learning; it&apos;s about experiencing.
                    Dive into hands-on industry exposure, earn rewarding incentives, and undergo
                    real-world training that will elevate your sales and marketing skills.
                  </p>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Are you a tech enthusiast with a passion for innovation? A versatile team
                    player eager to make an impact. Join us, and let&apos;s launch your career
                    into the dynamic world of IT sales and marketing at ERapid.
                  </p>
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-theme-blue mb-3">Key Responsibilities:</h4>
                    <ul className="list-disc list-inside text-gray-600 space-y-2">
                      <li>
                        Conduct market research to identify customers, trends, and competitors.
                      </li>
                      <li>
                        Assist in product sales at events, co-working spaces, and promotions.
                      </li>
                      <li>
                        Build customer relationships and address queries promptly.
                      </li>
                      <li>
                        Earn incentives for successful sales.
                      </li>
                      <li>
                        Analyze marketing and sales data and provide insights.
                      </li>
                      <li>
                        Attend training, workshops, and receive mentorship.
                      </li>
                      <li>
                        Able to attend events and travel for fieldwork.
                      </li>
                    </ul>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-theme-blue mb-3">Qualifications and Essentials:</h4>
                    <ul className="list-disc list-inside text-gray-600 space-y-2">
                      <li>
                        A Bachelor/Master degree in Engineering/Management (Pursuing or Completed)
                      </li>
                      <li>
                        Strong communication skills.
                      </li>
                      <li>
                        Enthusiastic about sales and marketing.
                      </li>
                      <li>
                        Ability to work independently and in a team.
                      </li>
                    </ul>
                  </div>
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-theme-blue mb-3">What We Offer:</h4>
                    <ul className="list-disc list-inside text-gray-600 space-y-2">
                      <li>Learning opportunity from industry experts.</li>
                      <li>Acquire valuable knowledge and skills.</li>
                      <li>
                        Exposure to real-world of sales and marketing.
                      </li>
                      <li>
                        Performance-Based Pre-Placement Offer (PPO) for outstanding interns
                        with growth opportunities
                      </li>
                      <li>Expand your network with industry professionals.</li>
                      <li>Explore different cities for events and promotions.</li>
                      <li>Unlock impressive incentives for stellar sales.</li>
                      <li>Earn a prestigious Certificate of Completion.</li>
                    </ul>
                  </div>
                  <div className="text-center">
                    <Button
                      href="/discuss-project"
                      type="link"
                      className="inline-flex items-center px-8 py-3 bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white rounded-lg shadow-lg hover:shadow-xl transform transition-all duration-300 hover:scale-105"
                    >
                      Apply Now
                      <svg className="ml-2 w-5 h-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Button>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </section>

        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
